module.exports = __webpack_public_path__ + "img/banner-1.e979b6dd.svg";